import { render } from "./contactButtons.vue?vue&type=template&id=befcae6a"
import script from "./contactButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./contactButtons.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/contacts/pages/contacts/list/components/contactButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "befcae6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('befcae6a', __exports__)) {
    console.log('reload')
    api.reload('befcae6a', __exports__)
  }
  
  module.hot.accept("./contactButtons.vue?vue&type=template&id=befcae6a", () => {
    console.log('re-render')
    api.rerender('befcae6a', render)
  })

}


export default __exports__